/**
 * @author       [Tim Vermaelen]
 * @date         [2023-2024]
 * @link         [http://www.adequatelygood.com/JavaScript-Module-Pattern-In-Depth.html]
 * @namespace    [Blastic.LanguageSwitcher]
 * @requires     [jQuery, Blastic]
 * @revision     [0.3]
 */

// @param ($): window.jQuery
// @param (ns): window.Blastic
window.Blastic = (function ($, ns) {

    // 1. ECMA-262/5
    'use strict';

    // 2. CONFIGURATION
  const cfg = {
      cache: {
        toggle: '#langToggleButton',
        languageLink: '[data-language] a[data-href]',
        switch: '.switch'
      },
      data: {
        href: 'href'
      },
      classes: {
        loaded: 'loaded'
      },
      events: {
          change: 'change'
      }
    };

    // 3. FUNCTIONS OBJECT
    ns.LanguageSwitcher = {

        revision: 0.3,

        init: function () {
            this.cacheItems();

            if (this.toggle) {
                this.activate();
            }
        },

        cacheItems: function () {
            const { cache } = cfg;

            this.toggle = document.querySelector(cache.toggle);
        },

        activate: function () {
            const { cache, classes } = cfg;

            const parent = this.toggle.closest(cache.switch);
            parent.classList.add(classes.loaded);

            this.verifyLanguage();
            this.bindEvents();
        },

        verifyLanguage: function () {
            const { cache, data } = cfg;
            const langVisible = $(cache.languageLink).filter(':visible');
            const pathname = langVisible.data(data.href);

            if (window.location.pathname !== pathname) {
                this.toggle.checked = !this.toggle.checked;
            }
        },

        bindEvents: function () {
            const { events } = cfg;

            this.toggle.addEventListener(events.change, this.handleToggle.bind(this));
        },

        handleToggle: function () {
            const { cache, data } = cfg;
            const langVisible = $(cache.languageLink).filter(':visible');
            const newPathName = langVisible.data(data.href);

            window.location.pathname = newPathName;
        }
    }

    // 4. NAMESPACE
    return ns;

})(window.jQuery, window.Blastic || {});
